import React, { useState } from "react";
import toast from "react-hot-toast";

// Helper function to generate a unique ID (for demonstration purposes)
const generateId = () => Math.random().toString(36).substring(2, 9);

const getFirstLastInitials = (fullName) => {
  const parts = fullName.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  const first = parts[0].charAt(0).toUpperCase();
  const last = parts[parts.length - 1].charAt(0).toUpperCase();
  return first + last;
};

// Comment component
const Comment = ({ avatarUrl, author, timestamp, text }) => {
  return (
    <div className="flex items-start space-x-4 p-4 bg-gray-50 rounded-lg shadow-sm mb-4">
      {/* Avatar */}
      <img
        src={
          avatarUrl ||
          `https://placehold.co/40x40/E0E0E0/808080?text=${getFirstLastInitials(
            author
          )}`
        }
        alt={`${author}'s avatar`}
        className="w-10 h-10 rounded-full object-cover border-2 border-gray-300"
        onContextMenu={(e) => e.preventDefault()}
        // onError={(e) => { e.target.onerror = null; e.target.src = `https://placehold.co/40x40/E0E0E0/808080?text=${author.charAt(0)}`; }}
      />
      <div className="flex-1">
        {/* Author and Timestamp */}
        <div className="flex items-center justify-between mb-1">
          <p className="font-semibold text-gray-800">{author}</p>
          <span className="text-sm text-gray-500">{timestamp}</span>
        </div>
        {/* Comment Text */}
        <p className="text-gray-700 leading-relaxed">{text}</p>
      </div>
    </div>
  );
};

// Comment Section component
export const CommentSection = () => {
  const [comments, setComments] = useState([
    {
      id: generateId(),
      author: "Aida Ndiaye",
      avatarUrl:
        "https://newhackerway.blob.core.windows.net/thumbnails/9.png?sp=r&st=2025-07-09T12:36:55Z&se=2029-07-09T20:36:55Z&sv=2024-11-04&sr=b&sig=icX9l%2FFCvZr5XPPcyRKupLxpbaV7TVsDjoKs%2BPBkoNY%3D", // Example placeholder
      timestamp: "Il y'a 2 heures",
      text: "Je suis une femme et je perdais mes cheveux par poignées. Après 2 mois de traitement, la chute a nettement ralenti. Je me sens beaucoup mieux dans ma peau.",
    },

    {
      id: generateId(),
      author: "Amadou Sall",
      avatarUrl:
        "https://newhackerway.blob.core.windows.net/images/30.png?sp=r&st=2025-07-03T11:58:17Z&se=2029-07-03T19:58:17Z&sv=2024-11-04&sr=b&sig=nw%2F8I%2BYe9MPwmYXr%2F5rnGc65Q%2BVA07pZNc1Ev6W3Y2E%3D", // Example placeholder
      timestamp: "Il y'a 2 heures",
      text: "Mon coiffeur a arrété de se moquer de moi",
    },
    {
      id: generateId(),
      author: "Cheikh Tall",
      avatarUrl:
        "https://newhackerway.blob.core.windows.net/images/13.png?sp=r&st=2025-07-03T11:02:10Z&se=2029-07-03T19:02:10Z&sv=2024-11-04&sr=b&sig=RllAuG%2BH29EMxodJyKyH9hJFb%2B2HCDpXtw18Rp2c8Fo%3D", // Example placeholder
      timestamp: "Il y'a 30 minutes",
      text: "Au début je croyais que c’était encore un de ces produits qui servent à rien. Mais après 1 mois, j’ai vu que mes cheveux commençaient à repousser un peu sur le devant. Maintenant j’attends de voir sur le long terme.",
    },
    {
      id: generateId(),
      author: "Babacar Fall",
      avatarUrl: "https://placehold.co/40x40/e6bfad/000000?text=BF", // Example placeholder
      timestamp: "Il y'a 5 minutes",
      text: "Je l’utilise depuis 3 mois matin et soir. C’est pas magique hein, mais je vois que mes cheveux sont un peu plus denses. Avant, je pouvais voir mon cuir chevelu facilement, maintenant un peu moins.",
    },
    {
      id: generateId(),
      author: "Ismael Ndaou",
      avatarUrl: "https://placehold.co/40x40/ade6d0/000000?text=ID", // Example placeholder
      timestamp: "Tout de suite",
      text: "Franchement j’étais à deux doigts de me raser tout… Mais Disaar m’a sauvé. C’est lent, faut être régulier, mais y a du résultat. Et surtout faut pas arrêter sinon les cheveux repartent, car pour ma part j'ai une alopécie androgénétique.",
    },
  ]);
  const [newCommentText, setNewCommentText] = useState("");
  const [newCommentAuthor, setNewCommentAuthor] = useState("");

  // Function to handle adding a new comment
  const handleAddComment = (e) => {
    e.preventDefault(); // Prevent default form submission
    if (newCommentText.trim() === "") {
      // In a real app, you'd show a custom modal or message here, not alert
      toast("Commentaire vide...");
      return;
    }

    const now = new Date();
    const timestamp = now.toLocaleString(); // Format date nicely

    const newComment = {
      id: generateId(),
      author: newCommentAuthor.trim() || "Anonymous", // Use 'Anonymous' if author is empty
      avatarUrl: "", // Can be dynamically generated or left empty for default
      timestamp: timestamp,
      text: newCommentText.trim(),
    };

    setComments([...comments, newComment]); // Add new comment to the list
    setNewCommentText(""); // Clear the text area
    setNewCommentAuthor("Samba Ba"); // Reset author to default
  };

  return (
    <div className="bg-white p-8 rounded-xl shadow-2xl max-w-2xl w-full animate-fade-in-up">
      <h2 className="text-2xl font-bold text-gray-900 mb-6">Commentaires</h2>
      {/* Comment List */}
      <div className="max-h-96 overflow-y-auto pr-2 custom-scrollbar">
        {" "}
        {/* Added custom-scrollbar for better UX */}
        {comments.map((comment) => (
          <Comment
            key={comment.id}
            avatarUrl={comment.avatarUrl}
            author={comment.author}
            timestamp={comment.timestamp}
            text={comment.text}
          />
        ))}
      </div>

      {/* Add New Comment Form */}
      <form
        onSubmit={handleAddComment}
        className="mt-6 pt-6 border-t border-gray-200"
      >
        <h3 className="text-xl font-semibold text-gray-800 mb-4">
          Faire un commentaire
        </h3>
        <div className="mb-4">
          <label
            htmlFor="authorName"
            className="block text-gray-700 text-sm font-bold mb-2"
          >
            Entrer votre Nom:
          </label>
          <input
            type="text"
            id="authorName"
            value={newCommentAuthor}
            onChange={(e) => setNewCommentAuthor(e.target.value)}
            placeholder="e.g., Samba Ba"
            className="shadow appearance-none border rounded-lg w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-gray-500 focus:border-transparent transition duration-200 ease-in-out"
          />
        </div>
        <div className="mb-4">
          <label
            htmlFor="commentText"
            className="block text-gray-700 text-sm font-bold mb-2"
          >
            Votre Commentaire:
          </label>
          <textarea
            id="commentText"
            value={newCommentText}
            onChange={(e) => setNewCommentText(e.target.value)}
            placeholder="Ecrivez votre commentaire ici..."
            rows={4}
            className="shadow appearance-none border rounded-lg w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-gray-500 focus:border-transparent transition duration-200 ease-in-out resize-y"
          ></textarea>
        </div>
        <button
          type="submit"
          className="w-full bg-black text-white font-bold py-3 px-6 rounded-lg shadow-lg transform transition duration-300 ease-in-out hover:scale-105 focus:outline-none focus:ring-4 focus:ring-djeliba"
        >
          Soumettre
        </button>
      </form>
    </div>
  );
};
